import audioTest from 'assets/audio/instructions/A1Ex1Kids.mp3';
import step1 from 'assets/img/instructions/step1.png';
import step2 from 'assets/img/instructions/step2.png';
import step3 from 'assets/img/instructions/step3.png';
import step6 from 'assets/img/instructions/step6.png';
import step7 from 'assets/img/instructions/step7.png';

export const instructionSteps = [
	{
		title: "Verifica tu nombre",
		description:
			"¿El nombre que aparece en tu examen está escrito de forma correcta?\nSi no, informa a tu profesor o al email: ellis.murguia@institutocertified.org.",
        button: "Si",
		image: step1
	},
	{
		title: "Tiempo necesario",
		description:
			"¿Cuentas con el tiempo necesario para realizar tu examen sin interrupciones?\nEPSt requiere hasta 139 minutos.",
        button: "Si",
		image: step2
	},
	{
		title: "Modo incógnito",
		description: "¿Ya estás en una ventana de incógnito del navegador Google Chrome?",
        button: "Si",
		image: step3
	},
	{
		title: "Prueba de audio",
		description: "¿Probaste tus audífonos o bocinas? Asegúrate de escuchar correctamente.",
        button: "Si",
        type: "audio-test",
	    audioSrc: audioTest
	},
	{
		title: "Prueba de micrófono",
		description: "¿Probaste tu micrófono? Asegúrate de que funcione correctamente.",
        button: "Si",
        type: "mic-test"
	},
	{
		title: "Navegación de preguntas",
		description: "Una vez que des click en el botón 'Submit' no podrás regresar a la pregunta anterior.",
        button: "Entendido",
		image: step6
	},
	{
		title: "Cambio de pestaña",
		description: "Si cambias o cierras la pestaña se te penalizará y perderás el examen. Para volver a presentar la certificación tendrás que realizar el pago nuevamente.",
        button: "Entendido",
		image: step7
	},
	{
		title: "Bloqueo del dispositivo",
		description: "Si se bloquea tu dispositivo se te penalizará y perderás el examen. Para volver a presentar la certificación tendrás que realizar el pago nuevamente.",
        button: "Entendido",
		image: step7
	},
	{
		title: "Confidencialidad",
		description:
			"El candidato se compromete a no divulgar ni compartir, ya sea total o parcialmente, el contenido del examen de certificación. Cualquier divulgación no autorizada puede resultar en la invalidación de los resultados del examen, así como en posibles sanciones o medidas disciplinarias.",
        button: "Acepto"
	},
	{
		title: "Fraude",
		description:
			"El fraude será descalificado:\n- Uso de materiales no permitidos\n- Suplantación de identidad\n- Uso de IA\n- Copiar o compartir respuestas.",
        button: "Acepto"
	},
	{
		title: "Confirmación",
		description:
			"Confirmo que he leído el reglamento, los manuales y he visto los videotutoriales. Conozco las indicaciones para realizar el examen.",
        button: "Acepto"
	}
];